import { render } from "./PushHeader.vue?vue&type=template&id=46194510"
import script from "./PushHeader.vue?vue&type=script&lang=js"
export * from "./PushHeader.vue?vue&type=script&lang=js"

import "./PushHeader.vue?vue&type=style&index=0&id=46194510&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__